
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class DocumentReportsDialog extends Serenity.EntityDialog<DocumentReportsRow, any> {
        protected getFormKey() { return DocumentReportsForm.formKey; }
        protected getIdProperty() { return DocumentReportsRow.idProperty; }
        protected getLocalTextPrefix() { return DocumentReportsRow.localTextPrefix; }
        protected getNameProperty() { return DocumentReportsRow.nameProperty; }
        protected getService() { return DocumentReportsService.baseUrl; }
        protected getDeletePermission() { return DocumentReportsRow.deletePermission; }
        protected getInsertPermission() { return DocumentReportsRow.insertPermission; }
        protected getUpdatePermission() { return DocumentReportsRow.updatePermission; }

        protected form = new DocumentReportsForm(this.idPrefix);

    }
}